import type { FinancePackage, FinanceQuoteLineItem } from "~/types/finance";

export const packageToLineItems = (
  pkg: FinancePackage,
): FinanceQuoteLineItem[] =>
  (pkg.lineItems ?? [])
    .filter((item) => item.name?.trim())
    .map((item) => ({
      name: item.name ?? "",
      quantity: item.quantity ?? 1,
      unit: item.unit ?? "EACH",
      unitPrice: item.price ?? 0,
      discountPercent: 0,
      markupPercent: 0,
      packageId: pkg._id,
      packageName: pkg.name,
    }));
